export default "__VITE_ASSET__wIOiCyQp__"